import { render, staticRenderFns } from "./FetchEmailCampaignsModal.vue?vue&type=template&id=25422874&"
import script from "./FetchEmailCampaignsModal.vue?vue&type=script&lang=ts&"
export * from "./FetchEmailCampaignsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QCardActions,QBtn}, component.options.components || {})
